import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";

export class response {
  data: any;
  errorCode: number;
  errorMessage: string;
  success: boolean
}

@Injectable({
  providedIn: "root"
})
export class AppService {


  //ATTRIBUTES
  imageFile: File = null;
  imageUrl: string = "";
  isLoading: boolean = false;
  // isLoadingObservable = new BehaviorSubject<boolean>(false);
  // Observable

  // isDoctor = new BehaviorSubject<boolean>(false);
  // isPatient = new BehaviorSubject<boolean>(false);

  isDoctor: boolean = false;
  isPatient: boolean = false;
  isContributor: boolean = false;
  IsSocialMediaManager: boolean = false;
  isPMSubscribed: boolean = false;

  // Handle LangCode ServerSide And ClintSide
  langServerSideCode = this?.router?.url?.includes('/en/') ? 'en' : 'ar';
  langBrowserSideCode = localStorage.Language ? localStorage.Language : 'ar'
  languageCode = isPlatformBrowser(this.platformId) ? this?.langBrowserSideCode : this.langServerSideCode
  // Handle LangCode ServerSide And ClintSide

  isPlatformBrowserVar = isPlatformBrowser(this.platformId) ? isPlatformBrowser(this.platformId) : false
  isPlatformServerVar = isPlatformServer(this.platformId) ? isPlatformServer(this.platformId) : false

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private meta: Meta,
    private title: Title,
    private toastr: ToastrService,
  ) { }

  // showLoading = () => Promise.resolve().then(() => this.isLoadingObservable.next(true));
  showLoading() {
    this.isLoading = true
  }
  // dismissLoading = () => Promise.resolve().then(() => this.isLoadingObservable.next(false));
  dismissLoading() {
    this.isLoading = false
  }

  getImageFile = (name: string) => name ? environment.imageBaseUrl + name : "assets/img/doctors/book-doctor-03.jpg"

  getImageFile2 = (name: string) => name ? environment.imageBaseUrl2 + name : "assets/img/doctors/book-doctor-03.jpg"

  getUserImage(name: string) {
    if (name) {
      return environment.imageBaseUrl + name
    } else if (!name) {
      if (this?.getUserData()?.gender == 1) {
        return "assets/img/icons/male.png"
      } else if (this?.getUserData()?.gender == 2) {
        return "assets/img/icons/female.png"
      } else if (!this?.getUserData()) {
        return "assets/img/icons/male.png"
      }
    }
  }

  getUserImage2 = (name: string) => name ? environment.imageBaseUrl2 + name : "assets/img/icons/male.png"

  getDoctorImage(name: string, gender: number) {
    if (name == null) {
      if (gender == 1) {
        return "assets/img/icons/male.png"
      } else if (gender == 2) {
        return "assets/img/icons/female.png"
      } else {
        return "assets/img/icons/male.png"
      }
    } else if (name) {
      return environment.imageBaseUrl + name
    }

  }

  getUserData = (): any => JSON.parse(localStorage.getItem(environment.appName + "UserData"));

  getUserLanguage = (): any => localStorage.Language;

  getUserDire = (): any => localStorage.Direction;

  checkRole() {
    const roles = this.getUserData()?.roles
    if (roles?.some(function (o) { return o["name"] == "User" }) && !roles.some(function (o) { return o["name"] == "HealthcareProvider" }) && !roles.some(function (o) { return o["name"] == "SocialMediaContributer" }) && !roles.some(function (o) { return o["name"] == "SocialMediaManager" })) {
      this.isPatient = true;
      this.isDoctor = false;
      this.isContributor = false;
      this.IsSocialMediaManager = false;
    } else if (roles?.some(function (o) { return o["name"] == "HealthcareProvider" })) {
      this.isPatient = false;
      this.isDoctor = true;
      this.isContributor = false;
      this.IsSocialMediaManager = false;
    }
    else if (roles?.some(function (o) { return o["name"] == "SocialMediaContributer" })) {
      this.isPatient = false;
      this.isDoctor = false;
      this.isContributor = true;
      this.IsSocialMediaManager = false;
    }
    else if (roles?.some(function (o) { return o["name"] == "SocialMediaManager" })) {
      this.isPatient = false;
      this.isDoctor = false;
      this.isContributor = false;
      this.IsSocialMediaManager = true;
    } else {
      this.isPatient = false;
      this.isDoctor = false;
      this.isContributor = false;
      this.IsSocialMediaManager = false;
    }
    this.checkIfIsPMSubscribed()
    if (this?.isContributor) {
      this.getHCPsForContributorAp();
    }
  }

  checkIfIsPMSubscribed() {
    if (this?.getUserData()?.isPMSubscibed == true) {
      this.isPMSubscribed = true
    } else {
      this.isPMSubscribed = false
    }
  }

  refreshTokenIfDoctorSubChanged() {
    if (!this.isDoctor || !this.getUserData()) { return }
    if (!localStorage.getItem(environment.appName + 'pmSub')) {
      var data = {
        value: 'pmSub',
        expiry: new Date().getTime() + 12 * 60 * 60 * 1000 // 12 hours from now
      };
      localStorage.setItem(environment.appName + 'pmSub', JSON.stringify(data));
    } else {
      var storedData = JSON.parse(localStorage.getItem(environment.appName + 'pmSub'));
      if (storedData.expiry > new Date().getTime()) {

      } else if (storedData.expiry < new Date().getTime()) {
        this.refreshToken();
        localStorage.removeItem(environment.appName + 'pmSub');
      }
    }
  }

  getRefreshTokenFromLocal() {
    let request = new FormData();
    request.append("RefreshToken", this.getUserData().refreshToken.refreshToken as string);
    return request;
  }

  refreshToken() {
    this.refreshTokenG(this.getRefreshTokenFromLocal()).subscribe(
      res => {
        if (res.errorCode == 0) {
          localStorage.removeItem(environment.appName + "UserData");
          localStorage.removeItem(environment.appName);
          localStorage.setItem(environment.appName + "UserData", JSON.stringify(res.data));
          localStorage.setItem(environment.appName, res.data.token);
          this.checkRole();
          this.refreshTokenIfDoctorSubChanged();
        }
      }
    )
  }

  getInsuranceSS = (): any => {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(sessionStorage.getItem(environment.appName + "HealthCareInsurance"));
    }
  }

  getMedicalServiceSS = (): any => {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(sessionStorage.getItem(environment.appName + "MedicalServices"));
    }
  }

  mainRouteToSearchComponent() {
    let medicalS = this?.languageCode == 'ar' ? 'جميع-التخصصات' : 'all-specialities'
    let insuranceS = this?.languageCode == 'ar' ? 'جميع-التأمينات' : 'all-insurance'
    let country = this?.languageCode == 'ar' ? 'الأردن' : 'jordan'
    let city = this?.languageCode == 'ar' ? 'جميع-المحافظات' : 'all-governorates'
    let area = this?.languageCode == 'ar' ? 'جميع-المناطق' : 'all-areas'
    this.router.navigate([`/${this?.languageCode}/search/${medicalS}/${country}/${city}/${area}/${insuranceS}`]);
  }

  mainLogOut() {
    localStorage.removeItem(environment.appName + "UserData");
    localStorage.removeItem(environment.appName);
    localStorage.removeItem(environment.appName + "SelectedCont");
    localStorage.removeItem(environment.appName + "SelectedObjCont");
    this.checkRole();
    if (this?.getUserLanguage() == 'en') {
      this.toastr.info("You've Been Logged Out");
    } else if (this?.getUserLanguage() == 'ar') {
      this.toastr.info("لقد تم تسجيل الخروج");
    }

    this.router.navigate([`/${this?.languageCode}/login-page`]);

    // this.router.navigate(['/' + this?.languageCode + '/login-page']).then(() => {
    // this.cd.detectChanges();
    // });
  }

  // getRouterParams = (getParam, getByIdFunction: Function) => {
  //   this.route.queryParams.subscribe(param => {
  //     if (!getParam) return;
  //     getByIdFunction();
  //   })
  // }


  // getFileUploader(e) {
  //   if (e.target.files) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(e.target.files[0])
  //     this.imageFile = e.target.files[0]
  //     reader.onload = (event: any) => {
  //       this.imageUrl = event.target.result
  //     }
  //   }
  // }

  // getDateFormate(date) {
  //   let indexT = date.indexOf("T");
  //   let dateAfterCrop = date.slice(0, indexT);
  //   let dd = dateAfterCrop.slice(8, dateAfterCrop.length);
  //   let mm = dateAfterCrop.slice(5, 7);
  //   let yyyy = dateAfterCrop.slice(0, 4);
  //   return (`${yyyy}-${mm}-${dd}`);
  // }


  // ConfirmDialogMessage(deleteFunction: Function) {
  //   let response = this.matDialog.open(ConfirmMessageComponent, { width: '500px' })
  //   response.afterClosed().subscribe((res: response) => {
  //     res && Promise.resolve(deleteFunction()).then(() => {
  //       this.showWarningMessage("Item Has Been Deleted")
  //     });
  //   });
  // }

  routeToDoctorProfileReturningOnlyNameAndSpech(doc, lang) {
    // ForHcpName
    let resHCPName;
    let HCPNameSplit = doc?.fullName?.split(' - ')
    let HCPNameSplitZero = HCPNameSplit[0]

    if (lang == 'ar') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        resHCPName = HCPNameSplit[0]
      } else {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      }
    } else if (lang == 'en') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      } else {
        resHCPName = HCPNameSplit[0]
      }
    }

    // let u = resHCPName?.replace(/ /gi, '-');
    // let c = u?.replace(/[(),.]/gi, '');
    // let j = c?.replace(/^(-)?/gi, '');

    let j = this.generateSlug(resHCPName)
    // ForHcpName

    // ForHcpSpecialty
    let resHCPSpecialty;
    let HCPSpecialtySplit = doc?.speciality?.split(' - ')
    let HCPSpecialtyZero = HCPSpecialtySplit[0]
    if (lang == 'ar') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        resHCPSpecialty = HCPSpecialtySplit[0]
      } else {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      }
    } else if (lang == 'en') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      } else {
        resHCPSpecialty = HCPSpecialtySplit[0]
      }
    }
    let x = this.generateSlug(resHCPSpecialty)
    // ForHcpSpecialty

    let l = `${j}-${x}`;
    return l;
  }

  routeToDoctorProfile(doc) {
    // ForHcpName
    let resHCPName;
    let HCPNameSplit = doc?.fullName?.split(' - ')
    let HCPNameSplitZero = HCPNameSplit[0]

    if (this?.languageCode == 'ar') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        resHCPName = HCPNameSplit[0]
      } else {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      }
    } else if (this?.languageCode == 'en') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      } else {
        resHCPName = HCPNameSplit[0]
      }
    }

    let j = this.generateSlug(resHCPName)
    // ForHcpName

    // ForHcpSpecialty
    let resHCPSpecialty;
    let HCPSpecialtySplit = doc?.speciality?.split(' - ')
    let HCPSpecialtyZero = HCPSpecialtySplit[0]
    if (this?.languageCode == 'ar') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        resHCPSpecialty = HCPSpecialtySplit[0]
      } else {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      }
    } else if (this?.languageCode == 'en') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      } else {
        resHCPSpecialty = HCPSpecialtySplit[0]
      }
    }
    let x = this.generateSlug(resHCPSpecialty)
    // ForHcpSpecialty

    let l = `${doc?.id}_${j}-${x}`
    this.router.navigate([`/${this?.languageCode}/doctor-profile/`, l]);
  }

  routeToDoctorProfileBlankNewTap(doc) {
    // ForHcpName
    let resHCPName;
    let HCPNameSplit = doc?.fullName?.split(' - ')
    let HCPNameSplitZero = HCPNameSplit[0]
    if (this?.languageCode == 'ar') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        resHCPName = HCPNameSplit[0]
      } else {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      }
    } else if (this?.languageCode == 'en') {
      if (this.isProbablyArabic(HCPNameSplitZero)) {
        if (HCPNameSplit[1]) {
          resHCPName = HCPNameSplit[1]
        } else {
          resHCPName = HCPNameSplit[0]
        }
      } else {
        resHCPName = HCPNameSplit[0]
      }
    }

    // let u = resHCPName?.replace(/ /gi, '-');
    // let c = u?.replace(/[(),.]/gi, '');
    // let j = c?.replace(/^(-)?/gi, '');
    let j = this.generateSlug(resHCPName)
    // ForHcpName

    // ForHcpSpecialty
    let resHCPSpecialty;
    let HCPSpecialtySplit = doc?.speciality?.split(' - ')

    let HCPSpecialtyZero = HCPSpecialtySplit[0]

    if (this?.languageCode == 'ar') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        resHCPSpecialty = HCPSpecialtySplit[0]
      } else {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      }
    } else if (this?.languageCode == 'en') {
      if (this.isProbablyArabic(HCPSpecialtyZero)) {
        if (HCPSpecialtySplit[1]) {
          resHCPSpecialty = HCPSpecialtySplit[1]
        } else {
          resHCPSpecialty = HCPSpecialtySplit[0]
        }
      } else {
        resHCPSpecialty = HCPSpecialtySplit[0]
      }
    }

    let x = this.generateSlug(resHCPSpecialty)
    // ForHcpSpecialty
    // let p = resHCPSpecialty?.replace(/ /gi, '-');
    // let x = p?.replace(/[(),.]/gi, '');
    // if (!x?.startsWith("-")) { // check if name does not start with a dash
    //   x = "-".concat(x); // add dash as the first character
    // }
    // ForHcpSpecialty

    let l = `${doc?.id}_${j}-${x}`
    const url = `https://www.ihospitalapp.com/${this?.languageCode}/doctor-profile/${l}`;
    window.open(url.toString(), '_blank')
  }

  routeToBlogDetails(blog, id) {
    let m
    if (!blog.slug) {
      m = this.generateSlug(blog.title)
    } else {
      m = this.generateSlug(blog.slug)
    }
    setTimeout(() => {
      this.router.navigate([`/${this?.languageCode}/blog-details/${id}_${m}`]);
    }, 100);
  }


  isProbablyArabic(str: string): boolean {
    var Character
    for (var i = 0; i < 5; i++) {
      let c = str.codePointAt(i);
      if (c >= 0x0600 && c <= 0x06E0)
        return true;
    }
    return false;
  }

  updateMetaService(content) {
    this.meta.updateTag({ name: 'description', content: `${content}` });
  }

  updateTitleService(content) {
    this.title.setTitle(`${content}`)
  }

  updateIndexMeta() {
    this.meta.updateTag({ name: 'robots', content: `noindex, nofollow` });
  }

  // for users
  searchVisitsForUsers = (req: object) => this.http.post<response>(environment.baseUrl + "Visit/search", req);


  // for docotrs
  searchVisitsForHcp = (req: object) => this.http.post<response>(environment.baseUrl + "hcp/visit/search", req);

  // get payment status after paying
  getPaymentStatus = (id: number) => this.http.get<any>(environment.baseUrl + "Payment/getPaymentStatus/" + id)

  // rate doctor
  // /api/Visit/rate
  rateHcp = (req: object) => this.http.post<any>(environment.baseUrl + "Visit/rate", req)

  refreshTokenG = (payload: FormData) => this.http.post<any>(environment.baseUrl + `Account/refreshToken`, payload);


  // forContributesSystem
  pageNumber = 0
  pageSize = 8;
  paginatorContribute(pageNumberInput) {
    this.pageNumber = pageNumberInput;
    const startIndex = this.pageNumber * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    let x = this.allHCPs.slice(startIndex, endIndex);
    this.HcpsAuth = this.HcpsAuth.concat(x);
  }

  // HcpsAuth;
  HcpsAuth: any[] = [];
  allHCPs;
  getHCPsForContributorAp() {
    let request = new FormData();
    request.append("PageSize", "999");
    request.append("PageNumber", "1");
    this.getHCPsForContributor(request).subscribe(
      res => {
        this.allHCPs = res.data.data
        if (res.data.totalRows > 8) {
          this.HcpsAuth = res.data.data.slice(0, 8);
        } else {
          this.HcpsAuth = res.data.data
        }
        if (this?.getSelectedHcpForCont()) {
          const selectedUser = this?.allHCPs?.find(x => x?.id == this?.getSelectedHcpForCont())
          this.allHCPs = this.allHCPs.filter(x => x.id != this?.getSelectedHcpForCont())
          this.HcpsAuth = this.HcpsAuth.filter(x => x.id != this?.getSelectedHcpForCont())
          this.HcpsAuth.unshift(selectedUser)
        }
      }
    )
  }

  getHCPsForContributor = (req: FormData) => this.http.post<response>(environment.baseUrl + "Account/SocialMedia/HasAccess/HCPs", req);

  setCont(hcp) {
    if (hcp?.id == this?.getSelectedHcpForCont()) { return }
    localStorage.setItem(environment.appName + "SelectedCont", hcp?.id);
    localStorage.setItem(environment.appName + "SelectedObjCont", JSON.stringify(hcp));
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }

  getSelectedHcpForCont = (): any => localStorage.getItem(environment.appName + "SelectedCont");
  getSelectedObjHcpForCont = (): any => JSON.parse(localStorage.getItem(environment.appName + "SelectedObjCont"));
  // forContributesSystem


  // Global Slug
  generateSlug(inputString) {
    const decodedString = decodeURIComponent(inputString);
    let result = decodedString.toLowerCase().trim();
    result = result.replace(/ - /g, '-');
    if (result.startsWith('-')) {
      result = result.substring(1);
    }
    result = result.replace(/\s+/g, '-');
    result = result.replace(/-{2,}/g, '-');
    result = result.replace(/[/\\[\]()،,.\^+$]/g, '');
    result = result.replace(/&/g, '');
    result = result.replace(/'/g, '');
    return result;
    // return encodeURIComponent(result);
  }
  // generateSlug(inputString) {
  //   const encodedString = decodeURIComponent(inputString);
  //   return encodedString
  //     .toLowerCase()
  //     .replace(/ /gi, '-')
  //     .replace(/-{2,}/g, '-')
  //     .replace(/[()،,.^+$]/gi, '');
  // }
  // Global Slug

  // checkTimingNow
  checkVisitTimeIfNow(from: string, to: string): boolean {
    const now = new Date();
    const nowPlus15Minutes = new Date(now.getTime() + 15 * 60000).getTime(); // 15 minutes in milliseconds
    const nowGetTimeWithout15 = new Date(now).getTime();
    const fromDate = new Date(from).getTime();
    const toDate = new Date(to).getTime();
    if (nowPlus15Minutes >= fromDate && nowGetTimeWithout15 <= toDate) {
      return true
    } else {
      return false
    }
  }
  // checkTimingNow

  // It takes the first 10 words from string and returns true if english > arabic, vice versa 
  isMostlyEnglish(input: string): boolean {
    const firstTenWords = input?.split(/\s+/)?.slice(0, 10);
    let englishCount = 0;
    let arabicCount = 0;
    firstTenWords?.forEach(word => {
      const containsEnglish = /[a-zA-Z]/.test(word);
      const containsArabic = /[\u0600-\u06FF]/.test(word);
      if (containsEnglish) {
        englishCount++;
      }
      if (containsArabic) {
        arabicCount++;
      }
    });
    return englishCount > arabicCount;
  }
}
